import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'nb',
  months: [
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember',
  ],
  monthsShort: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  weekdays: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
  weekdaysMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  weekdaysShort: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY H:mm',
    'lll-Y': 'D. MMM H:mm',
    llll: 'ddd D. MMM YYYY H:mm',
    'llll-Y': 'ddd D. MMM H:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: 'for %s år siden', other: 'for %s år siden' },
    M: { one: 'for %s mdg. siden', other: 'for %s mdg. siden' },
    w: { one: 'for %s uke siden', other: 'for %s uke siden' },
    d: { one: 'for %s dg. siden', other: 'for %s dg. siden' },
    h: { one: 'for %s t siden', other: 'for %s t siden' },
    m: { one: 'for %s min siden', other: 'for %s min siden' },
    s: { one: 'for %s sek siden', other: 'for %s sek siden' },
  },
  future: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s md.', other: 'om %s md.' },
    w: { one: 'om %s uke', other: 'om %s uker' },
    d: { one: 'om %s dg.', other: 'om %s dg.' },
    h: { one: 'om %s t', other: 'om %s t' },
    m: { one: 'om %s min', other: 'om %s min' },
    s: { one: 'om %s sek', other: 'om %s sek' },
  },
  pastLong: {
    y: { one: 'for %s år siden', other: 'for %s år siden' },
    M: { one: 'for %s måned siden', other: 'for %s måneder siden' },
    w: { one: 'for %s uke siden', other: 'for %s uker siden' },
    d: { one: 'for %s døgn siden', other: 'for %s døgn siden' },
    h: { one: 'for %s time siden', other: 'for %s timer siden' },
    m: { one: 'for %s minutt siden', other: 'for %s minutter siden' },
    s: { one: 'for %s sekund siden', other: 'for %s sekunder siden' },
  },
  futureLong: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s måned', other: 'om %s måneder' },
    w: { one: 'om %s uke', other: 'om %s uker' },
    d: { one: 'om %s døgn', other: 'om %s døgn' },
    h: { one: 'om %s time', other: 'om %s timer' },
    m: { one: 'om %s minutt', other: 'om %s minutter' },
    s: { one: 'om %s sekund', other: 'om %s sekunder' },
  },
  abbr: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s md.', other: '%s md.' },
    w: { one: '%s uke', other: '%s uker' },
    d: { one: '%s dg.', other: '%s dg.' },
    h: { one: '%s t', other: '%s t' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s sek', other: '%s sek' },
  },
  full: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s måned', other: '%s måneder' },
    w: { one: '%s uke', other: '%s uker' },
    d: { one: '%s døgn', other: '%s døgn' },
    h: { one: '%s time', other: '%s timer' },
    m: { one: '%s minutt', other: '%s minutter' },
    s: { one: '%s sekund', other: '%s sekunder' },
  },
  justNow: 'Akkurat nå',
  yesterday: 'I går',
  today: 'I dag',
  tomorrow: 'I morgen',
  weekStart: 1,
  timeRange: '%$1s–%$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd D. MMM YYYY', end: 'ddd D. MMM YYYY' },
    'Y-1': { start: 'ddd D. MMM', end: 'ddd D. MMM YYYY' },
    M: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    D: { start: 'ddd D. MMM', end: 'ddd D. MMM' },
    yt: { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm' },
    mt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    dt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D. MMM YYYY HH:mm', end: 'D. MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'nb';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'AM';
    } else {
      return isLowerCase ? 'p.m.' : 'PM';
    }
  },
};
